<template>
  <b-card>
    <b-modal id="confirmDeleteModal" v-model="showDeleteConfirm" title="Confirm Deletion" ok-title="Delete"
      cancel-title="Cancel" @ok="deleteTemplate" ok-variant="danger">
      <p>{{$t("Are you sure you want to delete this template?")}}</p>
    </b-modal>
    <b-row>
      <b-col cols="10">
        <h2 class="text-primary">{{ title }}</h2>
      </b-col>
      <b-col v-if="isUpdated" cols="2">
        <b-badge variant="warning" class="badge-glow">
          {{ $t('Not Saved') }}
        </b-badge>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col cols="12" class="d-flex justify-content-end">
        <b-form-checkbox v-model="createNewTemplate" @change="toggleCreateNewTemplate">
          {{ $t('Create New Template') }}
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-table id="my-table" ref="refUserListTable" class="position-relative" :items="items" responsive
      :fields="tableColumns" primary-key="id" show-empty :empty-text="$t('No matching records found')" 
      :current-page="currentPage" :per-page="perPage">
      <template #cell(templateTitle)="data">
        <div class="d-flex justify-content-center align-items-center mb-2">
          <span class="text-primary cursor-pointer" @click="handleClick(data.item)">
            {{ data.item.templateTitle }}
          </span>
        </div>
      </template>
      <template #cell(createdAt)="data">
        <div class="d-flex justify-content-center align-items-center mb-2">
          <span>{{ data.item.createdAt }}</span>
        </div>
      </template>
      <template #cell(clientMemberId)="data">
        <div class="d-flex justify-content-center align-items-center mb-2">
          <span>{{ data.item.clientMember != null ? data.item.clientMember.fullName : 'Unknown' }}</span>
        </div>
      </template>
      <template #cell(updatedAt)="data">
        <div class="d-flex justify-content-center align-items-center mb-2">
          <span>{{ data.item.updatedAt }}</span>
        </div>
      </template>
      <template #cell(updatedBy)="data">
        <div class="d-flex justify-content-center align-items-center mb-2">
          <span>
            {{ data.item.updatedByUser != null ? data.item.updatedByUser.fullName : 'Unknown' }}
          </span>
        </div>
      </template>
      <template #cell(actions)="data">
        <div class="d-flex justify-content-center align-items-center mb-2">
          <feather-icon :icon="'TrashIcon'" size="15" class="text-danger cursor-pointer" @click="handleDelete" />
        </div>
      </template>
    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
          <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} {{ $t('to') }} {{ dataMeta.to }} {{
            $t('of') }}
            {{ dataMeta.of }}
            {{ $t('entries') }}</span>
        </b-col>
        <!-- Pagination -->
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
          <b-pagination v-model="currentPage" :total-rows="totalUsers" :per-page="perPage" first-number last-number
            aria-controls="my-table" class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col sm="12">
        <b-form-group :label="$t('Mail Title')" label-for="templatetitle">
          <b-form-input v-model="selectedTemplate.templatetitle" name="mailtitle" :placeholder="$t('Mail Title')" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-form>
      <b-row>
        <!-- bio -->
        <b-col cols="12">
          <b-form-group label="" label-for="bio-area">
            <quill-editor v-model="selectedTemplate.template_content" height="300" :options="snowOption"
              @change="onEditorChange($event)" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
              @ready="onEditorReady($event)" />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-1 mr-1"
            :disabled="isLoading ? true : false" @click.prevent="createOrUpdateTemplate">
            {{ createNewTemplate ? $t("Add New Template") : $t("Save Changes") }}
          </b-button>
          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" class="mt-1"
            :disabled="isLoading ? true : false" variant="outline-secondary" @click.prevent="resetForm">
            {{ $t("Reset") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BFormTextarea,
  BBadge,
  BFormCheckbox,
  BTable,
  BModal,
  BPagination
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import Cleave from "vue-cleave-component";
import { quillEditor } from "vue-quill-editor";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import MailTemplateSelector from "./component/TemplateSelector.vue";

// eslint-disable-next-line import/no-extraneous-dependencies
import "cleave.js/dist/addons/cleave-phone.us";


export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BModal,
    BFormTextarea,
    vSelect,
    flatPickr,
    Cleave,
    quillEditor,
    BBadge,
    MailTemplateSelector,
    BFormCheckbox,
    BTable,
    BPagination
  },
  directives: {
    Ripple,
  },
  props: {
    title: {
      type: String,
      required: true,
      default: () => "",
    },

    informationData: {
      type: String,
      required: false,
      default: () => "",
    },
  },
  data() {
    return {
      perPage: 5,
      currentPage: 1,
      totalUsers: 0,
      snowOption: {
        theme: "snow",
      },
      items: [],
      createNewTemplate: false,
      isLoading: false,
      isUpdated: false,
      showDeleteConfirm: false,
      selectedTemplate: {
        id: null,
        templatetitle: "",
        template_content: "",
      },
      userData: JSON.parse(localStorage.getItem("userData")),
      canupdate: false,
      selectedContent: null,
      localOptions: JSON.parse(JSON.stringify(this.informationData ?? "")),
      tableColumns: [
        { key: 'templateTitle', label: 'Mail Title', sortable: true },
        { key: 'createdAt', label: 'Created Date', sortable: false },
        { key: 'clientMemberId', label: 'Created By', sortable: false },
        { key: 'updatedAt', label: 'Updated Date', sortable: false },
        { key: 'updatedBy', label: 'Updated By', sortable: false },
        { key: 'actions', label: 'Actions', sortable: false },
      ],
    };
  },
  created() {
    this.fetchMailTemplates();

  },

  methods: {
    async createOrUpdateTemplate() {
      this.isLoading = true;
      if (this.createNewTemplate) {
        await this.createNewTemplateFunc();
        await this.fetchMailTemplates();
      } else {
        this.sendInformation();
      }
    },
    handleDelete() {
      if (this.selectedTemplate?.id != null) {
        this.showDeleteConfirm = true
      } else {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Please select a template to delete`,
            icon: "AlertOctagonIcon",
            variant: "warning",
          },
        })
      }
    },

    toggleCreateNewTemplate(isChecked) {
      this.isUpdated = isChecked;
      if (isChecked) {
        this.selectedTemplate = {
          id: null,
          templatetitle: "",
          template_content: "",
        };
        this.canupdate = false;
      } else {
        if (this.items && this.items.length > 0) {
          this.selectedTemplate = {
            id: this.items[0].id,
            templatetitle: this.items[0].templateTitle,
            template_content: this.items[0].templateContent,
          }
        } else {
          this.selectedTemplate = {
            id: null,
            templatetitle: "",
            template_content: "",
          };
        }
      }
    },
    selectionChanged(value) {
      //console.log("template option Changed");
      //console.log(value);
      const contents = value.ClientMailTemplates;
      if (contents.length > 0) {
        this.selectedTemplate = contents[0];
        this.canupdate = true;
      } else {
        this.selectedTemplate = {
          id: null,
          templatetitle: "",
          template_content: "",
        };
        this.canupdate = false;
      }
    },

    fetchMailTemplates() {
      //console.log("fetchMailTemplates fetch");
      return new Promise((resolve, reject) => {
        axios
          .get("/admin/f/clientmailtemplates")
          .then((response) => {
            var data = response.data;
            var responseData = JSON.parse(JSON.stringify(data));
            //console.log(responseData.data);
            this.items = responseData.data;
            this.totalUsers = responseData.data.length;
            if (this.items && this.items.length > 0) {
              this.selectedTemplate = {
                id: this.items[0].id,
                templatetitle: this.items[0].templateTitle,
                template_content: this.items[0].templateContent,
              };
            } else {
              this.selectedTemplate = {
                id: null,
                templatetitle: "",
                template_content: "",
              };

            }
          })
          .catch((error) => reject(error));
      });
    },
    createNewTemplateFunc() {
      return new Promise((resolve, reject) => {
        axios
          .post("/admin/f/clientmailtemplate", {
            templateTitle: this.selectedTemplate.templatetitle,
            templateContent: this.selectedTemplate.template_content,
            clientMemberId: this.userData.id,
          })
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: `Create Template Success`,
                icon: "CheckCircleIcon",
                variant: "success",
              },
            });
            this.isLoading = false;
            this.isUpdated = false;
            resolve(response);
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: `Create Template Error`,
                icon: "AlertOctagonIcon",
                variant: "warning",
              },
            });
            this.isLoading = false;
            reject(error);
          });
      });
    },
    handleClick(item) {
      this.selectedTemplate = {
        id: item.id,
        templatetitle: item.templateTitle,
        template_content: item.templateContent,
      };
      this.createNewTemplate = false;
    },
    deleteTemplate() {
      this.isLoading = true;
      axios({
        method: "delete",
        url: `/admin/f/clientmailtemplate/${this.selectedTemplate.id}`,
      })
        .then((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "CheckCircleIcon",
              variant: "success",
            },
          });
          this.isLoading = false;
          this.isUpdated = false;
          this.fetchMailTemplates();
        })
        .catch((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "AlertOctagonIcon",
              variant: "warning",
            },
          });
          this.isLoading = false;
        });
    },
    sendInformation() {
      this.isLoading = true;
      axios({
        method: "put",
        url: `/admin/f/clientmailtemplate/${this.selectedTemplate.id}`,
        data: {
          templateTitle: this.selectedTemplate.templatetitle,
          templateContent: this.selectedTemplate.template_content,
          updatedBy: this.userData.id,
        },
      })
        .then((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "CheckCircleIcon",
              variant: "success",
            },
          });
          this.isLoading = false;
          this.isUpdated = false;
          this.fetchMailTemplates();
        })
        .catch((r) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "AlertOctagonIcon",
              variant: "warning",
            },
          });
          this.isLoading = false;
        });

    },

    resetForm() {
      this.localOptions = JSON.parse(
        JSON.stringify(this.informationData ?? "")
      );
    },
    onEditorBlur(quill) {
      //    //console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      //   //console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      //     //console.log('editor ready!', quill)
    },
    onEditorChange({ quill, html, text }) {
      //     //console.log('editor change!', quill, html, text)
      this.isUpdated = true;

      if (this.selectedTemplate != null) {
        this.selectedTemplate.template_content = html;
      }
    },
  },
  computed: {
    dataMeta() {
      const localItemsCount = this.items ? this.items.length : 0
      const from = this.perPage * (this.currentPage - 1) + (localItemsCount ? 1 : 0)
      return {
        from,
        to: (from + this.perPage) > this.totalUsers ? this.totalUsers : from + this.perPage - 1,
        of: this.totalUsers,
      }
    },
    editor() {
      //   return this.$refs.myQuillEditor.quill
    },
  },
  mounted() {
 
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

@import "@core/scss/vue/libs/quill.scss";

.ql-editor {
  min-height: 400px;
}
</style>
